<template lang="pug">
  #eventActivitySuccess.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.text-center.w-100(
      style="flex: 1 1 0;"
    )
      .pt-5
        img.p-2(
          :src='okImg',
          alt='success_ok_img',
          width="80",
          style="border-radius: 100%;"
        )
        p.font-weight-bold.mb-0 預約成功
        hr.border-primary.w-100
        .grayArea.py-5.m-3.text-center(v-if=userInfo)
          h6 {{ userInfo.eventActivity.name }}
          p.pt-2.mb-0 {{ userInfo.selectedDate.activity_start_at }}
          p.pt-2.mb-0 {{ moment(userInfo.selectedDate.activity_start_at + " " + userInfo.selectedTime.activity_start_time).format("HH:mm") }} ~ {{ moment(userInfo.selectedDate.activity_start_at + " " + userInfo.selectedTime.activity_end_time).format("HH:mm") }}

    .d-flex.justify-content-center
      button.btn.btn-block.btn-primary.w-50(
        type="button",
        @click="backToLINEHandler()"
      ) 返回官方帳號
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_black_ok.png';
import { mapState } from 'vuex';
const moment = require('moment');

export default {
  name: 'reservationSuccess',
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    moment(val) {
      return moment(val);
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.member_event_activity.userInfo
    })
  }
};
</script>

<style lang="scss" scoped>
.grayArea {
  background-color: #F0F0F0;
}
</style>
